export type Feedback = {
  label: number;
  content: string;
  username: string;
};

export const FEEDBACK_LABEL = {
  BUG_REPORT: 0,
  FEATURE_REQUEST: 1,
  REPORT_USER: 2,
  OTHER: 3,
} as const;

export type FeedbackLabel =
  (typeof FEEDBACK_LABEL)[keyof typeof FEEDBACK_LABEL];

const FEEDBACK_LABEL_TEXT: Record<FeedbackLabel, string> = {
  [FEEDBACK_LABEL.BUG_REPORT]: "Bug Report",
  [FEEDBACK_LABEL.FEATURE_REQUEST]: "Feature Request",
  [FEEDBACK_LABEL.REPORT_USER]: "Report User",
  [FEEDBACK_LABEL.OTHER]: "Other",
};

export function getFeedbackLabels() {
  return Object.values(FEEDBACK_LABEL).map((value) => ({
    label: FEEDBACK_LABEL_TEXT[value],
    value,
  }));
}
